import { render } from "./hr-review.vue?vue&type=template&id=e03eb410"
import script from "./hr-review.vue?vue&type=script&lang=js"
export * from "./hr-review.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__